// extracted by mini-css-extract-plugin
export default {"getOutline":"FiltersDashboard_getOutline__hKFjL","CardWhiteArea":"FiltersDashboard_CardWhiteArea__dokss","CardBlueArea":"FiltersDashboard_CardBlueArea__udQ+2"};